import { render, staticRenderFns } from "./StatementsUpdateTable.vue?vue&type=template&id=31c1b287&"
import script from "./StatementsUpdateTable.vue?vue&type=script&lang=ts&"
export * from "./StatementsUpdateTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports